import { MOBEES_API_URL } from '@shared/constants/API.constants';

export const buildPostMobeesFormApiConfig = campaignId => ({
    method: 'POST',
    url: `/api/campaigns/${campaignId}/pay`,
    baseURL: MOBEES_API_URL,
});
